export const PORTFOLIO_ROUTE_NAMES = {
  STUDENT_PORTFOLIO_INDEX: "studentPortfolioIndex",
  STUDENT_ASSIGNMENT: "studentAssignment",
  STUDENT_TASKS: "studentTasks",
  STUDENT_OPEN_ASSIGNMENTS: "studentOpenAssignments",
  TEACHER_SCHEDULED_TASK: "teacherScheduledTask",
  TEACHER_PENDING_REVIEW_TASKS: "teacherPendingReviewTasks",
  TEACHER_SCHEDULED_TASK_CREATE: "teacherScheduledTaskCreate",
  TEACHER_OPEN_SCHEDULED_TASKS: "teacherOpenScheduledTasks",
  TEACHER_COMPLETED_SCHEDULED_TASKS: "teacherCompletedScheduledTasks",
  TEACHER_TASK_LIBRARY_INDEX: "teacherTaskLibraryIndex",
  MY_STUDENTS: "myStudentsPortfolio",
  MY_LESSONGROUPS: "myLessongroupsPortfolio",
} as const;

export type PortfolioRouteName =
  (typeof PORTFOLIO_ROUTE_NAMES)[keyof typeof PORTFOLIO_ROUTE_NAMES];
